import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import aboutSectionImg1 from "../../assets/images/aboutSectionImg1.webp";
import aboutSectionImg2 from "../../assets/images/aboutSectionImg2.JPG.jpeg";
import aboutSectionImg3 from "../../assets/images/aboutSectionImg3.jpeg";
import PrimaryButton from "../common/PrimaryButton";
import { useNavigate } from "react-router-dom";

const NewWhoWeAre = () => {
  const navigate = useNavigate();
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div
      className={`${
        theme === "dark" ? "bg-white" : "bg-black"
      } sm:py-10 sm:px-10 transition-all duration-500`}
    >
      <div
        className={`${
          theme === "dark" ? " bg-white" : "sm:shadow-[0_0_20px_5px] sm:shadow-[#8D19DA] sm:bg-gradient"
        }  sm:p-4 relative z-10 sm:rounded-[16px] max-w-screen-2xl mx-auto transition-all duration-500`}
      >
        <div className={`${theme === 'dark' ? "bg-white" : "bg-black"} w-full mx-auto py-16 px-4 sm:px-6 lg:px-8 relative sm:rounded-[16px]`}>
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
            <div className="max-w-lg sm:mb-20 relative flex flex-col items-center sm:items-start">
              <h2
                className={`${
                  theme === "dark" ? "text-gray-900" : "text-white"
                } transition-all duration-500 text-3xl bricolage-grotesque-bold  mb-4 sm:mb-8 sm:text-5xl relative z-10`}
              >
                Who We Are 
              </h2>

              <p
                className={`${
                  theme === "dark" ? "text-gray-900" : "text-white"
                } mt-4 font-gtAmerica transition-all duration-500 text-center sm:text-left sm:text-2xl`}
              >
                We are a group of innovative thinkers and doers who go above and beyond to help our clients achieve their goals. One thing that sets us apart from the competition is our understanding of how crucial it is for entrepreneurs to remain competitive in every way. We recognize the grind that goes into all of this. And for that reason, we are here.
              </p>
              <div>
                <div>
                  <PrimaryButton
                    onClick={() => navigate("/who-we-are")}
                    className={`${
                      theme === "dark"
                        ? "bg-white !text-black hover:!text-white hover:bg-secondary border !border-secondary hover:shadow-[0_0_10px_2px] hover:shadow-secondary"
                        : "border  border-secondary bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
                    } relative mt-10 z-10 transition-all duration-500`}
                  >
                    Know More
                  </PrimaryButton>
                </div>
              </div>
            </div>
            <div className="overflow-hidden">
              <div className="grid grid-cols-2 gap-4 sm:gap-10 h-[300px] sm:h-auto">
                <img
                  src={aboutSectionImg1}
                  className="row-span-2 h-[300px] sm:h-full object-cover rounded-3xl"
                  alt=""
                />
                <img
                  src={aboutSectionImg2}
                  className="object-cover rounded-2xl h-[142px] sm:h-full"
                  alt=""
                />
                <img
                  src={aboutSectionImg3}
                  className="object-cover rounded-2xl h-[142 px] sm:h-full"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewWhoWeAre;
